import { render, staticRenderFns } from "./barre.vue?vue&type=template&id=e2d330da"
import script from "./barre.js?vue&type=script&lang=js&external"
export * from "./barre.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports